import { gql } from '@apollo/client'

export const SUB_ACTION_GENERATOR_STATS_FRAGMENT = gql`
  fragment SubActionGeneratorStats on ActionGeneratorStats {
    id
    title
    description
    repeatSchedule
    startDate
    actionType
    numStores
    completionPercentage
    ignoredPercentage
  }
`
